<template>
  <div id="purchased-components-cost-estimator" class="content">
    <h1 class="header">{{ pageTitle }}</h1>
    <div class="content-body">
      <div class="block">
        <div data-test-id="cost-estimator-info">
          <div class="qty-indicator" v-if="costEstimator">
            <span class="qty-indicator--number">{{ costEstimator.manufacturer_part ? costEstimator.manufacturer_part.chinese_name : '' }}</span>
            &nbsp;
            <span class="qty-indicator--title">{{ $t('cost.part_cost_form.quantity') }}</span>
            <span class="qty-indicator--number">{{ costEstimator.quantity }}</span>
            &nbsp;
            <span class="qty-indicator--title">{{ $t('cost.part_cost_form.currency') }}</span>
            <span class="qty-indicator--number">{{ costEstimator.root_assembly_part_cost.currency }}</span>
            &nbsp;
            <span class="qty-indicator--title">{{ $t('exchange_rate') }}</span>
            <span class="qty-indicator--number">{{ costEstimator.root_assembly_part_cost.exchange_rate }}</span>
            &nbsp;
            <span v-if="costEstimator.bom_version" class="qty-indicator--title">{{ $t('cost.part_cost_form.bom_version') }}</span>
            <span v-if="costEstimator.bom_version" class="qty-indicator--number">{{ costEstimator.bom_version }}</span>
            &nbsp;
            <span class="qty-indicator--title">{{ $t('date') }}</span>
            <span class="qty-indicator--number">{{ moment(costEstimator.created_at).format('YYYY-MM-DD') }}</span>
            <div class="text-align-right" style="float: right">
              <div v-if="costEstimator">
                <router-link :to="{ name: 'menu.estimators.assembled_part_costed_bom_list', params: {id: costEstimator.id } }">{{ $t('cost.part_cost_form.back_to_cost_estimator_top_page') }}</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="margin-top-20">
          <MaterialLineItems :part-cost="costEstimator.root_assembly_part_cost" v-if="costEstimator && costEstimator.material_cost_id"></MaterialLineItems>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MaterialLineItems, AssembledPartCostInfo } from './components'
import { mapActions } from 'vuex'
import moment from 'moment'
export default {
  name: 'PurchasedComponentsCostEstimator',
  data () {
    return {
      costEstimator: null
    }
  },
  components: {
    MaterialLineItems,
    AssembledPartCostInfo
  },
  computed: {
    pageTitle () {
      document.title = this.$t('cost.materials.purchased_parts_cost_title') + (this.costEstimator ? ' - ' + this.costEstimator?.manufacturer_part?.display_name : '')
      return document.title
    }
  },
  mounted () {
    this.loadCostEstimatorInfo(this.$route.params.id)
  },
  watch: {
    '$route.params.id': function(newVal) {
      if (newVal) {
        this.loadCostEstimatorInfo(newVal)
      }
    }
  },
  methods: {
    ...mapActions([
      'getCostEstimatorInfo'
    ]),
    moment,
    loadCostEstimatorInfo(id) {
      this.getCostEstimatorInfo(id).then(res => {
        if (res.status === 200) {
          this.costEstimator = res.data
        }
      })
    }
  }
}
</script>

<style lang="less">
.qty-indicator {
    margin-bottom: 55px;
    .qty-indicator--number, .qty-indicator--title {
      display: inline-block;
      min-width: 50px;
      border: 1px solid #cccccc4d;
      padding: 1px 5px;
      background: #cccccc3d;
      border-radius: 0 4px 4px 0;
      color: #999;
      text-align: center;
      font-weight: bold;
    }
    .qty-indicator--title {
      border-radius: 4px 0 0 4px;
      text-align: right;
      border-right: 0;
    }
}
</style>
